function csrf_token_init() {
  // Set CSRF token for jQuery requests
  $.ajaxSetup({
    headers: {
      'X-CSRFToken': $.cookie('csrftoken'),
    }
  });
}

function show_notification(message, type = null, destroy = true) {
  if (destroy) {
    iziToast.destroy();
  }

  iziToast[type]({
    message: message,
    position: (type == 'error') ? 'center' : 'topCenter',
    transitionIn: 'fadeIn',
    progressBar: false,
    timeout: 5000,
    zindex: 99999,
  });
}

function show_error(title) {
  show_notification(title, 'error');
}

function show_warning(title) {
  show_notification(title, 'warning');
}

function show_success(title) {
  show_notification(title, 'success');
}

function add_loading(elem) {
  if (elem) {
    elem.addClass('is-loading');
  }
}

function remove_loading(elem) {
  if (elem) {
    elem.removeClass('is-loading');
  }
}

function animated_cells(css_class, count) {
  if (count < 10) {
    count = 10;
  }
  let animated_cell = '<tr><td class="' + css_class + '" colspan="12"><div class="animated-background"></div></td></tr>';
  let html = "";
  for (let i = 0; i < count; i++) {
    html += animated_cell;
  }
  return html;
}

function getFormData(form) {
  var unindexed_array = form.serializeArray();
  var indexed_array = {};
  $.map(unindexed_array, function (n, i) {
    indexed_array[n['name']] = n['value'];
  });
  return indexed_array;
}

function select2_config(obj, url, placeholder) {
  $(obj).select2({
    ajax: {
      url: url,
      dataType: 'json',
      delay: 250,
      cache: true,
    },
    placeholder: placeholder,
    minimumInputLength: 3,
    language: {
      inputTooShort: function (args) {
        return "Upiši 3 ili više slova";
      }
    }
  });
}

(function ($, _) {
  $.fn.replaceOptions = function (options, selected) {
    var self, $option;
    this.empty();
    self = this;
    $.each(options, function (index, option) {
      $option = $("<option></option>")
        .attr("value", index)
        .text(option);
      if (index == selected) {
        $option.prop('selected', true);
      }
      self.append($option);
    });
  };
})(jQuery, window);

$(function () {
  csrf_token_init();
  async_init();
});
